import { Injectable } from '@angular/core';
import{LoginResponse} from '../models/login/login'
import { HttpClient,HttpParams, HttpHeaders,HttpErrorResponse} from '@angular/common/http';
// import { RequestOptions } from '@angular/http';
import {Observable,throwError,BehaviorSubject } from 'rxjs';
import {catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import {User} from '../models/user'
@Injectable({
  providedIn: 'root'
})
export class LoginService {
  private loginURL: string;
  private logOutURL: string;
  private changePasswordURL:string;
  private forgotPassowrdUrl:string;
  private resetPasswordUrl: string;

  constructor(private http: HttpClient) { 
    this.loginURL = environment.apiUrl + '/auth/login';
    this.changePasswordURL = environment.apiUrl+'/auth/changePassword';
    this.logOutURL=environment.apiUrl + '/logout';
    this.forgotPassowrdUrl=environment.apiUrl + '/auth/forgotPassword';
    this.resetPasswordUrl = environment.apiUrl + '/auth/resetPassword';
  }
    private PageTitle = new BehaviorSubject<string>('Dashboard')
    currentPageTitle = this.PageTitle.asObservable(); 
    changePageTitle(PageTitle: any) {
    this.PageTitle.next(PageTitle)
    }
    private profile = new BehaviorSubject<any>('')
    currentProfile = this.profile.asObservable(); 
    changeProfile(profile: any) {
    this.profile.next(profile)
    }
    private isLogin = new BehaviorSubject<boolean>(false)
    currentStatus = this.isLogin.asObservable(); 
    changeStatus(login: boolean) {
    this.isLogin.next(login)
    }
    getLogin(loginObj:any): Observable<User> {
    console.log("loginObj",loginObj);
    return this.http.post<any>(this.loginURL, loginObj)
    }
    changePassword(Obj:any): Observable<User> {
      console.log("loginObj",Obj);
      return this.http.post<any>(this.changePasswordURL, Obj)
      }
    forgotPassword(loginObj:any): Observable<User> {
      console.log("loginObj",loginObj);
      return this.http.post<any>(this.forgotPassowrdUrl, loginObj)
      }


    logOut(filterObj): Observable<any>{
    return this.http.get('this.logOutURL'+encodeURIComponent(JSON.stringify(filterObj))); 
    }
    resetPassword(postBody) {
      return this.http.post(this.resetPasswordUrl, postBody)
    }
}
